import { Component, input, output } from '@angular/core';
import { BUTTON_SIZE, BUTTON_TYPES } from '@shared/components/button/button-types.enum';

@Component({
  selector: 'app-button',
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  ariaLabel = input('')
  buttonStyleType = input<BUTTON_TYPES>(BUTTON_TYPES.SECONDARY_0);
  type = input<'submit' | 'button' | 'reset'>();
  icon = input<string>();
  disabled = input<boolean>(false);
  preventDef = input<boolean>(true);
  noWordWrap = input<boolean>(false);
  maxWidth = input<string>('100%');
  buttonSize = input<BUTTON_SIZE>(BUTTON_SIZE.SLIM);
  clicked = output<MouseEvent>();


  get btnClass(): string {
    let result = `${this.buttonStyleType()} ${this.buttonSize()}`;
    if (this.noWordWrap()) {
      result += ' no-word-wrap';
    }
    return result;
  }

  clickButton($event: MouseEvent) {
    if (this.preventDef()) {
      $event.preventDefault();
    }
    this.clicked.emit($event);
  }
}
